module.exports = "/images/qizhi_96e4d3.png";